import logo from "./logo.svg";
import "./App.css";
import img from "./Images/Rectangle 6667501.png";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import MainLayout from "./MainLayout/MainLayout";
import WinnersHome from "./View/WinnersHome/WinnersHome";
import Footer from "./Layout/Footer";
import PropertyList from "./View/PropertyList/PropertyList";
import Community from "./View/Community/Community";
import WinnersAboutUs from "./View/AboutUs/WinnersAboutUs";
import Pricingplans from "./View/Pricing Plans/Pricingplans";
import Career from "./View/Career/Career";
import Profile from "./View/Profile/Profile";
import ListOfFavourites from "./View/PropertyList/ListOfFavourites";
import CommunityList from "./View/Community/CommunityList";
import Blog from "./View/Blog/Blog";
import UserProfile from "./View/Profile/UserProfile";
import EditProfile from "./View/Profile/EditProfile";
import BlogDetails from "./View/Blog/BlogDetails";
import WebPopup from "./Component/WebPopup";
import CommunityFav from "./View/Community/CommunityFav";
import ActivePropertyList from "./View/PropertyList/ActivePropertyList";
import NewPropertyList from "./View/PropertyList/NewPropertyList";
import DeactivePropertyList from "./View/PropertyList/DeactivePropertyList";
function App() {
  return (
    <>
      <WebPopup />
      <BrowserRouter>
      
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route path="/" element={<WinnersHome />} />
            <Route path="/propertylist" element={<PropertyList />} />
            <Route path="/communitylist" element={<Community />} />
            {/* <Route path='/communitylist' element={<CommunityList/>}/> */}
            <Route path="/aboutus" element={<WinnersAboutUs />} />
            <Route path="/pricingplan" element={<Pricingplans />} />
            <Route path="/career" element={<Career />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/list-of-favourites" element={<ListOfFavourites />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog-details" element={<BlogDetails />} />
            {/* <Route path='/user-profile' element={<UserProfile/>}/> */}
            <Route path="/edit-profile" element={<EditProfile />} />
            <Route path="/community-fav-list" element={<CommunityFav />} />
            <Route path="/active-properties" element={<ActivePropertyList />} />
            <Route path="/new-properties" element={<NewPropertyList />} />
            <Route path="/deactive-properties" element={<DeactivePropertyList />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
